export const workerScriptLoader = (workerCode: Function) => {
    let code: string = workerCode.toString();

    code = code.substring(code.indexOf('{') + 1, code.lastIndexOf('}'));

    const blob = new Blob([code], {
        type: 'application/javascript'
    });

    const workerScriptBlob = URL.createObjectURL(blob);

    return workerScriptBlob;
}